import React, { useState } from 'react';
import styled from 'styled-components';

import { Paper, Accordion, AccordionSummary, Typography, Grid } from '@material-ui/core';

import ModalUploadLoadProfile from '../modals/ModalUploadLoadProfile';
import IconLoadProfile from '../../assets/icon-load-profile.svg';
import IconPlus from '../../assets/icon-plus.svg';
import CardWrapper from '../common/CardWrapper';

const Root = styled(Paper)`
	background-color: transparent;

	.MuiAccordion-root {
		background-color: ${(props) => props.theme.palette.blocks.cardWrapper.background};
		border-radius: 0;
		box-shadow: none;
	}

	.MuiAccordionSummary-root,
	.MuiAccordionSummary-content {
		margin: 0;
		padding: 0;
	}

	.MuiIconButton-root {
		position: absolute;
		bottom: -42px;
		background-color: ${(props) => props.theme.palette.blocks.cardWrapper.background};
		padding: 10px;
		box-shadow: rgb(0 0 0 / 30%) 0px 5px 0px 0;

		img {
			max-width: 25px;
			width: 100%;
			height: auto;
		}
	}

	.MuiAccordionSummary-expandIcon.Mui-expanded {
		transform: none;
	}

	.accordion {
		display: flex;
		align-items: center;

		.accordion__icon {
			flex: 0;
			padding: 20px 40px 20px 20px;

			img {
				width: 80px;
			}
		}

		.accordion__content {
			flex: 1;

			h2 {
				margin-bottom: 10px;
				font-size: 24px;
				font-weight: bold;
				text-transform: uppercase;
			}
		}
	}
`;

const LastgangHochladenCard = () => {
	const [openLastgangHochladen, setOpenLastgangHochladen] = useState(false);

	const toggleLastgangHochladenModal = () => {
		setOpenLastgangHochladen(!openLastgangHochladen);
	};

	return (
		<Root>
			<CardWrapper>
				<Accordion>
					<AccordionSummary
						expandIcon={<img src={IconPlus} alt="Erweitern" />}
						aria-controls="panel1a-content"
						id="panel1a-header"
						onClick={() => setOpenLastgangHochladen(true)}
					>
						<Grid container className="accordion">
							<Grid item className="accordion__icon">
								<img src={IconLoadProfile} alt="Lastgang hochladen" />
							</Grid>
							<Grid item className="accordion__content">
								<Typography variant="h2">
									Lastgang hochladen und Einsparpotential berechnen
								</Typography>
								<Typography>
									Mit metis.light können Sie Ihren individuellen
									Lastgang hochladen und erhalten sofort erste
									Optimierungsoptionen für Ihr Energiesystem.
								</Typography>
							</Grid>
						</Grid>
					</AccordionSummary>
					<ModalUploadLoadProfile
						toggleModal={toggleLastgangHochladenModal}
						openLastgangDialog={openLastgangHochladen}
					/>
				</Accordion>
			</CardWrapper>
		</Root>
	);
};

export default LastgangHochladenCard;
